import React from 'react';
import axios from 'axios';

import { createAlert } from './alert-service';
import { getVersion } from './version-service';
import { hardReload } from '../utils';
import { isDev, isElectron } from 'services/env-service';

const UPDATE_INTERVAL = 2 * 60 * 1000;

const handleReloadClick = event => {
    event.preventDefault();

    hardReload();
}

const updateAlert = createAlert('alert', (
    <div>We've made some Nifty updates! Please <a href="/dashboard" onClick={handleReloadClick}>refresh your browser</a> to use the latest version.</div>
), {
    duration: 0,
    hard: true,
    hidden: true
});

export const initAppUpdate = () => {
    if (isElectron() || isDev()) {
        return;
    }

    initInterval();

    checkAppVersion();
}

const initInterval = () => {
    setInterval(checkAppVersion, UPDATE_INTERVAL);
}

const checkAppVersion = () => {
    axios({
        method: 'get',
        url: `/version?${new Date().getTime()}`
    }).then(response => {
        const latestVersion = response.data;
        const currentVersion = getVersion();

        if (latestVersion !== currentVersion) {
            showUpdatesAlert();
        }
    });    
}

const showUpdatesAlert = () => {
    updateAlert.show();
}
